<template>
<div>
  <div class="meta-views meta-data"
       v-bind="engagementTooltip">
      <span @click="tooltipMobile()">
      <div class="meta-title"
           v-if='totalEngagementProjects && !leaderboard'>
        ENGAGEMENT
      </div>
      <span class="engagement"
            v-if='leaderboard'>
        {{$t('leaderBoard.engagement')}}<i class="fal fa-info-circle"></i>
      </span>
      <span class="engagement-container">
          <span v-if="!leaderboard"
                class="is-size-7 has-text-weight-semibold">
            {{ !leaderboard ? totalEngagementProjects || totalEngagementUser : 0 }}
          </span>
          <i class="fal fa-fingerprint"
             v-if='!leaderboard' />
      </span>
      <span v-if="engagementIsOpen"
            data-balloon-visible
            :data-balloon="tooltipText"
            :data-balloon-pos="tooltipPosition"
            data-balloon-length="medium"
            class="is-hidden-tablet mobile-tooltip" />
      </span>
  </div>
</div>
</template>

<script>
import breakpoints from '@/libs/breakpoints'
import i18n from '@/i18n'

export default {
  props: ['totalEngagementUser', 'totalEngagementProjects', 'leaderboard'],
  data: function () {
    return {
      engagementIsOpen: false,
      tooltipText: this.totalEngagementProjects ? i18n.t('projectPage.engagementCount') : i18n.t('projectPage.engagementCountUser'),
      tooltipPosition: this.totalEngagementProjects ? 'down-left' : 'down-right'
    }
  },
  computed: {
    isMobile: function () {
      return breakpoints.isMobile()
    },
    engagementTooltip: function () {
      if (this.isMobile) {
        return
      }
      const tooltip = {}
      tooltip['data-balloon'] = this.tooltipText
      tooltip['data-balloon-pos'] = 'down'
      tooltip['data-balloon-length'] = 'large'
      return tooltip
    }
  },
  methods: {
    tooltipMobile: function () {
      this.engagementIsOpen = !this.engagementIsOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/utils.scss";

.engagement-container{
  cursor: pointer;
  &:hover {
    color: $primary;
    transition:0.5s;
  }

  @media only screen
  and (max-height: 430px)
  and (orientation: landscape) {
    height: 26px !important;
  }
}
.meta-views{
  display: inline-block;
  @include mobile {
    display: block;
  }
}

.engagement:hover .fa-info-circle {
  color: $primary;
}

i {
  padding-left: 0.4rem;
}
</style>
